import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

const fetchOnBoardingStep = () => {
  const newEndpoints = endpoints.onBoardingStep;
  return http().get(newEndpoints);
};

export function useFetchOnBoardingStep(options?: any): UseQueryResult<any> {
  return useQuery({ queryKey: ['fetchOnBoardingStep'], queryFn: () => fetchOnBoardingStep(), ...options });
}
